import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'exclamation-mark', 'ExclamationMark', [["path",{"d":"M12 19v.01","key":"svg-0"}],["path",{"d":"M12 15v-10","key":"svg-1"}]]);